import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BehaviorsModule } from '@ddv/behaviors';
import { CommonComponentsModule } from '@ddv/common-components';
import { NamedQueriesModule } from '@ddv/named-queries';
import { LibSvgIconsModule, StackedAreaChartIconComponent } from '@ddv/svg-icons';
import { CheckboxComponent, OptionToggleComponent } from '@hs/ui-core-inputs';
import { IconComponent } from '@hs/ui-core-presentation';

import { BarColorComponent } from './bar-color/bar-color.component';
import { CellAndFontColorComponent } from './cell-and-font-color/cell-and-font-color.component';
import { ColorChartComponent } from './color-chart/color-chart.component';
import { ColumnBaseFormattingComponent } from './column-base-formatting/column-base-formatting.component';
import { ColumnFormattingGridComponent } from './column-formatting-grid/column-formatting-grid.component';
import { ColumnFormattingSummaryComponent } from './column-formatting-summary/column-formatting-summary.component';
import { ColumnTooltipFormattingComponent } from './column-tooltip-formatting/column-tooltip-formatting.component';
import { ColumnValueFormattingComponent } from './column-value-formatting/column-value-formatting.component';
import { ConditionalFormattingComponent } from './conditional-formatting/conditional-formatting.component';
import { ConfigurationFieldComponent } from './configuration-field/configuration-field.component';
import { ConfigurationZoneComponent } from './configuration-zone/configuration-zone.component';
import { ConfigureChartsComponent } from './configure-charts/configure-charts.component';
import { ConfigureGridComponent } from './configure-grid/configure-grid.component';
import { ConfigureSummaryComponent } from './configure-summary/configure-summary.component';
import { DynamicComponent } from './dynamic.component';
import { FieldPickerTreeComponent } from './field-picker-tree/field-picker-tree.component';
import { FormatBarComponent } from './format-bar/format-bar.component';
import { FormatStackedAreaChartComponent } from './format-stacked-area-chart/format-stacked-area-chart.component';
import { FormatSummaryComponent } from './format-summary/format-summary.component';
import { FormatVizComponent } from './format-viz/format-viz.component';
import { LineChartColorComponent } from './line-chart-color/line-chart-color.component';
import { MWLeftNavComponent } from './manage-widgets-left-nav/manage-widgets-left-nav.component';
import { MultiColorPickerComponent } from './multi-color-picker/multi-color-picker.component';
import { MultiSelectComponent } from './multi-select/multi-select.component';
import { VisualizationNavHeaderComponent } from './visualization-nav-header/visualization-nav-header.component';

@NgModule({
    imports: [
        BehaviorsModule,
        CheckboxComponent,
        CommonComponentsModule,
        CommonModule,
        DragDropModule,
        FormsModule,
        BarColorComponent,
        CellAndFontColorComponent,
        IconComponent,
        LibSvgIconsModule,
        LineChartColorComponent,
        MultiColorPickerComponent,
        NamedQueriesModule,
        OptionToggleComponent,
        ReactiveFormsModule,
        ConfigurationFieldComponent,
        StackedAreaChartIconComponent,
    ],
    declarations: [
        ColorChartComponent,
        ColumnBaseFormattingComponent,
        ColumnFormattingGridComponent,
        ColumnFormattingSummaryComponent,
        ColumnTooltipFormattingComponent,
        ColumnValueFormattingComponent,
        ConditionalFormattingComponent,
        ConfigurationZoneComponent,
        ConfigureChartsComponent,
        ConfigureGridComponent,
        ConfigureSummaryComponent,
        DynamicComponent,
        FieldPickerTreeComponent,
        FormatBarComponent,
        FormatStackedAreaChartComponent,
        FormatSummaryComponent,
        FormatVizComponent,
        MWLeftNavComponent,
        MultiSelectComponent,
        VisualizationNavHeaderComponent,
    ],
    exports: [
        MWLeftNavComponent,
    ],
})
export class LeftNavModule {}
